module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec04_pc_b4b863dafd8d40e9b84648bc7cfb63e3.jpg";